<template>
  <div class="toast-position">
    <div class="toast-container">
      <transition-group name="toastDown">
        <div class="toast col-block" :class="[toast.type]" v-for="(toast, index) in toasts" :key="index + 0" @mouseenter="e => keepToast(toast)" @mouseleave="e => leaveToast(toast, index)">
          <div class="option">
            <img :src="require('../../assets/images/toast-times.svg')" alt="" @click="e => removeToast(index)">
          </div>
          <div class="title">{{ { error: 'Error !', success: 'Success !' }[toast.type] }}</div>
          <div :style="{ height: '14px' }"></div>
          <div class="content" v-html="toast.content"></div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      toasts: []
    }
  },
  computed: {
    ...mapGetters([
      'toast'
    ])
  },
  watch: {
    'toast' (nv) {
      let id = (new Date()).getTime() + ''
      this.toasts.push({
        ...nv,
        id: id,
        clearTimer: null,
        timer: setTimeout(() => {
          this.toasts.splice(this.toasts.indexOf(this.toasts.find(toast => toast.id === id)), 1)
        }, 5000)
      })
    }
  },
  methods: {
    keepToast (toast) {
      toast.clearTimer = setTimeout(() => {
        clearTimeout(toast.timer)
        toast.clearTimer = null
      }, 500)
    },
    leaveToast (toast, index) {
      if (toast.clearTimer) {
        clearTimeout(toast.clearTimer)
      } else {
        this.removeToast(index)
      }
    },
    removeToast (index) {
      this.toasts.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/toast.vue